module.exports = __webpack_public_path__ + "static/mac_fuirmidh_cittern-bfa12e149de5017dead69a3fd1374c8d.jpg";